export * from './area.service'


// WEBPACK FOOTER //
// /app/src/shared/services/index.ts